require('./bootstrap');

// Vendor Imports
import { createApp } from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

// Local Imports
import App from '@/App.vue'
import router from '@/router'
import store from '@/store/index'

const app = createApp(App)
    .use(router)
    .use(store)
    .use(VueAxios, axios)
    .mount('#app')
